export default "__VITE_ASSET__BmnYOs$k__"